import { DEFAULT_FIRST_GET_DATA_AMOUNT, DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { createRef, useEffect, useState } from 'react';
import axios from '../../../lib/axios';
import {
  GET_PRODUCT_ON_HAND_FROM_SBC,
  PRODUCT_DELETE,
  PRODUCT_FIND_MANY,
  UPDATE_STOCK_FROM_SBC,
} from '../../../lib/endpoints/product';
import { BrandModel } from '../../../models/brand';
import { MerChantModel } from '../../../models/merChantModel';
import { useRef } from 'react';
import { MainGroupModel } from '../../../models/mainGroup';
import { DivisionModel } from '../../../models/division';
import { CategoryModel } from '../../../models/category';
import { SubCategoryModel } from '../../../models/subCategory';
import { ProductMerchantModel, updateProductMerchant } from '../../../models/productMerchant';
import { concatenateStrings } from '../../../utils/concatenateStrings';
import { ProductBadgeEnum } from '../../../enums/productBadge';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import {
  getCountProductMerchant,
  getProductMerchant,
  handleGetProductMerchantByCategory,
  handleSearchProductMerchant,
  handleSearchProductMerchantByItemCode,
  updateProductMerchantById,
} from '../../../services/productMerchant';
import { getMerchantData } from '../../../services/merchant';
import { getMainGroupByMerchantId } from '../../../services/mainGroup';
import { getAllBandProduct } from '../../../services/bandProduct';
import { getDivisionByMerchantId } from '../../../services/division';
import { getCategoriesByMerchantId } from '../../../services/categories';
import { getSubCategoriesByMerchantId } from '../../../services/subCategory';

export const useProductMerchantController = () => {
  const [isInit, setIsInit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingDataTable, setLoadingDataTable] = useState<boolean>(true);
  const [loadingFetchDataMore, setLoadingFetchDataMore] = useState<boolean>(false);
  const [loadingUploadData, setLoadingUploadData] = useState<boolean>(false);
  const [loadingRefreshStock, setLoadingRefreshStock] = useState<boolean>(false);
  const [loadingExportCSVButton, setLoadingExportCSVButton] = useState<boolean>(false);

  const [data, setData] = useState<ProductMerchantModel[]>([]);

  const [dataBrand, setDataBrand] = useState<BrandModel[]>([]);
  const [dataMerchants, setDataMerchants] = useState<MerChantModel[]>([]);

  const [dataMainGroup, setDataMainGroup] = useState<MainGroupModel[]>([]);
  const [dataDivisions, setDataDivisions] = useState<DivisionModel[]>([]);
  const [dataCategories, setDataCategories] = useState<CategoryModel[]>([]);
  const [dataSubCategories, setDataSubCategories] = useState<SubCategoryModel[]>([]);

  const [dataMainGroupForSelect, setDataMainGroupForSelect] = useState<MainGroupModel[]>([]);

  const [dataDivisionForSelect, setDataDivisionForSelect] = useState<DivisionModel[]>([]);

  const [dataCategoryForSelect, setDataCategoryForSelect] = useState<CategoryModel[]>([]);
  const [dataSubCategoryForSelect, setDataSubCategoryForSelect] = useState<SubCategoryModel[]>([]);

  const [mainGroupValue, setMainGroupValue] = useState<string>('All');

  const [divisionValue, setDivisionValue] = useState<string>('All');

  const [categoryValue, setCategoryValue] = useState<string>('All');

  const [subCategoriesValue, setSubCategoriesValue] = useState<string>('All');

  const [dataExportCsv, setDataExportCsv] = useState<any>([]);

  const [productStatusType, setProductStatusType] = useState<ProductBadgeEnum>(
    ProductBadgeEnum.AllProduct
  );

  const [merchant, setMerchant] = useState<string>(null!);

  const [selectedData, setSelectedData] = useState<ProductMerchantModel>(null!);
  const [countAllProduct, setCountAllProduct] = useState<number>(0);

  const [selectedCheckboxId, setSelectedCheckboxId] = useState<string[]>([]);
  const [selectedId, setSelectedId] = useState<string>(null!);

  const [searchValue, setSearchValue] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);

  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [isFormUpdateData, setIsFormUpdateData] = useState<boolean>(false);

  const roleAdmin = useSelector((state: RootState) => state?.auth?.data?.role?.role_type);

  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);

  const searchRef = useRef<HTMLInputElement>(null!);
  const buttonExportCsv = createRef<any>();

  const handleFetchProductMerchantById = async (): Promise<void> => {
    try {
      const getMerchant = dataMerchants.find((item: MerChantModel) => item?.id === merchant);
      const { id, merchantCode }: any = getMerchant;
      await updateProductMerchantById(id, merchantCode);
    } catch (error) {
      console.log(error);
    } finally {
      await handleGetProductMerchant();
    }
  };

  const handleRefetchData = async () => {
    try {
      const merchants = await getMerchantData();

      if (merchants?.length > 0) {
        const merchantId = merchants[0]?.id;

        const resProducts = await getProductMerchant({ merchantId, take: 30 });
        const resCountMerchant = await getCountProductMerchant({ merchantId });

        setData(resProducts);
        setCountAllProduct(resCountMerchant);
      } else {
        console.warn('No merchants found');
      }
    } catch (err) {
      console.log('Error fetching data:', err);
    }
  };

  const handleGetData = async () => {
    setLoading(true);
    setLoadingDataTable(true);
    try {
      const merchants = await getMerchantData();

      if (merchants?.length > 0) {
        const merchantId = merchants[0]?.id;

        const resProducts = await getProductMerchant({ merchantId, take: 30 });
        const resCountMerchant = await getCountProductMerchant({ merchantId });
        const resMainGroup = await getMainGroupByMerchantId({ merchantId });
        const resDivision = await getDivisionByMerchantId({ merchantId });
        const resCategories: any = await getCategoriesByMerchantId({ merchantId });
        const resSubCategories: any = await getSubCategoriesByMerchantId({ merchantId });
        const resBand = await getAllBandProduct();

        const matchingMerchants = merchants.filter((merchant) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );

        if (roleAdmin === 'SUPER_ADMIN') {
          setDataMerchants(merchants);
          setMerchant(merchantId);
        } else if (roleAdmin === 'ADMIN' && matchingMerchants.length > 0) {
          setDataMerchants(matchingMerchants);
          setMerchant(matchingMerchants[0]?.id);
        }

        setData(resProducts);
        setCountAllProduct(resCountMerchant);
        setDataMainGroup(resMainGroup);
        setDataDivisions(resDivision);
        setDataCategories(resCategories);
        setDataSubCategories(resSubCategories);
        setDataBrand(resBand);
        setDataMainGroupForSelect(resMainGroup);
      } else {
        console.warn('No merchants found');
      }
    } catch (err) {
      console.log('Error fetching data:', err);
    } finally {
      setLoading(false);
      setLoadingDataTable(false);
    }
  };

  const handleMerchantChange = async (e: any) => {
    try {
      setCurrentPage(1);
      setData([]);
      setMainGroupValue('All');
      setDivisionValue('All');
      setCategoryValue('All');
      setSubCategoriesValue('All');
      setProductStatusType(ProductBadgeEnum.AllProduct);
      const merchantId = e.target.value;
      setMerchant(merchantId);

      setLoadingDataTable(true);
      const resProducts = await getProductMerchant({ merchantId, take: 30 });
      const resCountMerchant = await getCountProductMerchant({ merchantId });
      const resMainGroup = await getMainGroupByMerchantId({ merchantId });
      const resDivision = await getDivisionByMerchantId({ merchantId });
      const resCategories: any = await getCategoriesByMerchantId({ merchantId });
      const resSubCategories: any = await getSubCategoriesByMerchantId({ merchantId });

      setData(resProducts);
      setCountAllProduct(resCountMerchant);
      setDataMainGroup(resMainGroup);
      setDataDivisions(resDivision);
      setDataCategories(resCategories);
      setDataSubCategories(resSubCategories);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingDataTable(false);
    }
  };

  const handleGetProductMerchant = async () => {
    try {
      setData([]);
      setLoadingDataTable(true);
      const resProducts = await getProductMerchant({ merchantId: merchant, take: 30 });
      const resCountMerchant = await getCountProductMerchant({ merchantId: merchant });
      const resMainGroup = await getMainGroupByMerchantId({ merchantId: merchant });
      const resBand = await getAllBandProduct();
      const resDivision = await getDivisionByMerchantId({ merchantId: merchant });
      const resCategories: any = await getCategoriesByMerchantId({ merchantId: merchant });
      const resSubCategories: any = await getSubCategoriesByMerchantId({ merchantId: merchant });

      setData(resProducts);
      setCountAllProduct(resCountMerchant);
      setDataMainGroup(resMainGroup);
      setDataDivisions(resDivision);
      setDataCategories(resCategories);
      setDataBrand(resBand);
      setDataSubCategories(resSubCategories);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleGetProductByStatusNewProductAndRecommend = async (
    status: ProductBadgeEnum
  ): Promise<void> => {
    try {
      setLoadingDataTable(true);
      let filtter = {};
      if (status === ProductBadgeEnum.NewProduct) {
        filtter = { productNew: true, merchantId: merchant };
        setCurrentPage(1);
      } else if (status === ProductBadgeEnum.RecommendProduct) {
        filtter = { recommend: true, merchantId: merchant };
        setCurrentPage(1);
      } else if (status === ProductBadgeEnum.AllProduct) {
        filtter = {};
        handleGetProductMerchant();
        setCurrentPage(1);
      }

      const { data: resData } = await axios.post(PRODUCT_FIND_MANY, {
        filtter,
      });

      setData(resData);
    } catch (err) {
      console.error('Error fetching products:', err);
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleSelectedStatusProduct = (newValue: ProductBadgeEnum) => {
    setProductStatusType(newValue);
    setCurrentPage(1);
    handleGetProductByStatusNewProductAndRecommend(newValue);
  };

  const handleGetProductByMainGroupCategory = async (
    mainId: string,
    divisionId: string,
    categoryId: string,
    subCategoryId: string
  ): Promise<void> => {
    try {
      setLoadingDataTable(true);

      const filter = {
        mainId,
        divisionId,
        categoryId,
        subCategoryId,
        merchant,
        take: 30,
      };

      const resData = await handleGetProductMerchantByCategory(filter);

      setData(resData);
    } catch (err) {
      console.error('Error fetching products:', err);
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleFetchDataMore = async () => {
    try {
      setLoadingFetchDataMore(true);
      const params: any = {
        take: 30,
        skip: data?.length,
        productMainGroupId: mainGroupValue !== 'All' ? mainGroupValue : '',
        productDivisionNameId: divisionValue !== 'All' ? divisionValue : '',
        productCategoryId: categoryValue !== 'All' ? categoryValue : '',
        productSubCategoryId: subCategoriesValue !== 'All' ? subCategoriesValue : '',
        merchantId: merchant,
      };
      if (productStatusType === ProductBadgeEnum.RecommendProduct) {
        params.recommend = true;
      }
      if (productStatusType === ProductBadgeEnum.NewProduct) {
        params.productNew = true;
      }
      const resPro = await getProductMerchant(params);
      const newData = [...data, ...resPro];
      setData(newData);
    } catch (err) {
    } finally {
      setLoadingFetchDataMore(false);
    }
  };

  const handlePageChange = (_: any, newPage: any) => {
    if (newPage === countPagination) {
      if (!loadingFetchDataMore) {
        handleFetchDataMore();
      }
    }
    setCurrentPage(newPage);
  };

  const handleExportCsv = async () => {
    try {
      setLoadingExportCSVButton(true);
      const resData = await axios.post(PRODUCT_FIND_MANY, {
        filtter: { merchantId: merchant },
        // take: DEFAULT_FIRST_GET_DATA_AMOUNT,
        // skip: currentPage,
      });
      setDataExportCsv(
        resData?.data?.map((item: ProductMerchantModel) => {
          return {
            id: item?.id,
            productNameEn: item?.price?.masterProduct.productNameEn,
            productNameLa: item?.price?.masterProduct?.productNameLa,
            itemcode: item?.price?.masterProduct?.itemcode,
            barcodes: concatenateStrings(item?.price?.masterProduct?.barcodes),
            zone: item?.zone,
            recommend: item?.recommend === true ? 'Recommend' : '',
            newProduct: item?.productNew === true ? 'NewProduct' : '',
            packType: item?.price?.masterProduct?.packType,
            sales_amount: item?.saleAmount,
            price: item?.price?.price,
            isActive: item?.isActiveStatus === true ? 'Active' : 'InActive',
            quantity: item?.inventory?.quantity ?? 0,
          };
        })
      );
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingExportCSVButton(false);
    }
  };

  const handleRefreshStock = async () => {
    try {
      setLoadingRefreshStock(true);
      if (merchant) {
        await axios.get(
          `${GET_PRODUCT_ON_HAND_FROM_SBC}?BranchCode=${
            dataMerchants.filter((item) => item?.id === merchant)[0]?.merchantCode
          }`
        );
        window.alert('ສຳເລັດ');
        window.location.reload();
      } else {
        window.alert('Select merchant first!');
      }
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingRefreshStock(false);
    }
  };

  const handleRefreshStockFromSbcByMerchant = async () => {
    try {
      setLoadingUploadData(true);
      if (merchant) {

        await axios.get(
          `${UPDATE_STOCK_FROM_SBC}?merchantCode=${
            dataMerchants.filter((item) => item?.id === merchant)[0]?.merchantCode
          }`
        );

        await handleRefetchData();
        window.alert('ການດຶງສະຕ໊ອກຈາກ SBC ສຳເລັດ');
      } else {
        window.alert('Select merchant first!');
      }
    } catch (err) {
      console.log('err=', err);
      window.alert('error ການດຶງສະຕ໊ອກຈາກ SBC ບໍ່ສຳເລັດ');
    } finally {
      setLoadingUploadData(false);
    }
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
    setProductStatusType(ProductBadgeEnum.AllProduct);
  };

  const handleSearchProduct = async () => {
    try {
      setLoadingDataTable(true);
      if (searchValue) {
        setCurrentPage(1);
        const newData = await handleSearchProductMerchant(searchValue, merchant);
        console.log(newData);

        setData(newData);
      } else {
        await handleGetProductMerchant();
      }
    } catch (err) {
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleUpdateProductByCsv = async (e: any) => {
    try {
      setLoadingUploadData(true);
      const files = Array.from(e.target.files) as File[];

      // Assume only one file is selected
      const file = files[0];
      const reader = new FileReader();

      reader.onload = async (event) => {
        const csvData = event.target?.result as string;
        // Parse CSV data into an array of objects
        const lines = csvData.split('\n').filter((line) => line.trim() !== '');
        const headers = lines[0].split(',').map((header) => header.trim());
        const productForUpload: any = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i].split(',');
          if (values.length !== headers.length) {
            window.alert(`Line ${i + 1} is malformed and will be skipped.`);
            continue;
          }

          const productObject: any = {};
          for (let j = 0; j < headers.length; j++) {
            productObject[headers[j]] = values[j]?.trim() || '';
          }

          productForUpload.push(productObject);
        }

        if (productForUpload.length > 0) {
          if (
            window.confirm(
              'ທ່ານຕ້ອງການທີ່ຈະແກ້ໄຂສິນຄ້າຈຳນວນ ' + productForUpload.length + ' ລາຍການ'
            )
          ) {
            for (let i = 0; i < productForUpload.length; i++) {
              const input: any = {
                recommend: productForUpload[i].recommend ? true : false,
                productNew: productForUpload[i].newProduct ? true : false,
                zone: productForUpload[i].zone,
                saleAmount: parseInt(productForUpload[i].salesAmount?.toString() || '0'),
              };
              try {
                // await axios.post('/sendSms', input);
                await updateProductMerchant(productForUpload[i].id?.toString() || '', input);
              } catch (error) {
                window.alert(`ມີປັນຫາໃນການແກ້ໄຂຂໍ້ມູນທີ (${i + 1})`);
                return;
              }
            }
          }
        }
        window.alert(`ແກ້ໄຂສິນຄ້າສຳເລັດ (${productForUpload.length}) ລາຍການ`);
        setLoadingUploadData(false);
      };

      reader.onerror = (event) => {
        window.alert('Error occurred while reading the file.');
        setLoadingUploadData(false);
      };

      reader.readAsText(file);
    } catch (err) {
      window.alert('An unexpected error occurred.');
      setLoadingUploadData(false);
    }
  };

  const onChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const onOpenForm = () => {
    setOpenMenu(null);
    setOpenForm(true);
  };

  const onCloseForm = () => {
    setOpenForm(false);
    setIsFormUpdateData(false);
  };

  const onOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
    setSelectedData(data?.filter((item) => item?.id === getId)[0]);
  };

  const onDeleteData = () => {
    setData(data?.filter((item) => item?.id !== selectedId));
    setOpenMenu(null!);
  };

  const onDeleteSelectedData = () => {
    let newData = data;
    for (let i = 0; i < selectedCheckboxId.length; i++) {
      newData = newData?.filter((item) => item?.id !== selectedCheckboxId[i]);
    }

    setData(newData);
    setSelectedCheckboxId([]);
  };

  const onSearch = (e: any) => {
    setCurrentPage(1);
    setSearchValue(e.target.value);
  };

  const onSelectCheckBox = (event: any, getId: string) => {
    const selectedIndex = selectedCheckboxId.indexOf(getId);
    let newSelected: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedCheckboxId, getId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(1));
    } else if (selectedIndex === selectedCheckboxId.length - 1) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedCheckboxId.slice(0, selectedIndex),
        selectedCheckboxId.slice(selectedIndex + 1)
      );
    }
    setSelectedCheckboxId(newSelected);
  };

  const onSelectCheckBoxAll = (event: any) => {
    if (event.target.checked) {
      const newSelecteds: any = filterData.map((n) => n.id);
      setSelectedCheckboxId(newSelecteds);
      return;
    }
    setSelectedCheckboxId([]);
  };

  const onCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleMainGroupChange = async (e: any) => {
    const newValue = e.target.value;
    setMainGroupValue(newValue);
    setCurrentPage(1);

    if (newValue === 'All') {
      setDataDivisionForSelect([]);
    } else {
      const filteredDivisions = dataDivisions.filter(
        (item) => item?.main_group_name_id === newValue
      );
      setDataDivisionForSelect(filteredDivisions);
    }

    // Reset other dropdowns
    setDataCategoryForSelect([]);
    setDataSubCategoryForSelect([]);
    setDivisionValue('All');
    setCategoryValue('All');
    setSubCategoriesValue('All');

    // Fetch data based on mainId and default (or 'All') values for other IDs
    await handleGetProductByMainGroupCategory(newValue, 'All', 'All', 'All');
  };

  const handleDivisionChange = async (e: any) => {
    const divisionId = e.target.value;
    setDivisionValue(divisionId);
    setCurrentPage(1);

    if (divisionId === 'All') {
      setDataCategoryForSelect([]);
    } else {
      setDataCategoryForSelect(
        dataCategories.filter((item) => item?.division_name_id === divisionId)
      );
    }

    // Reset other dropdowns
    setDataSubCategoryForSelect([]);
    setCategoryValue('All');
    setSubCategoriesValue('All');

    // Fetch data based on selected values
    await handleGetProductByMainGroupCategory(mainGroupValue, divisionId, 'All', 'All');
  };

  const handleCategoryChange = async (e: any) => {
    const categoryId = e.target.value;
    setCurrentPage(1);
    setCategoryValue(categoryId);

    if (categoryId === 'All') {
      setDataSubCategoryForSelect([]);
    } else {
      setDataSubCategoryForSelect(
        dataSubCategories.filter((item) => item?.product_category_id === categoryId)
      );
    }

    // Reset subcategory dropdown
    setSubCategoriesValue('All');

    // Fetch data based on selected values
    await handleGetProductByMainGroupCategory(mainGroupValue, divisionValue, categoryId, 'All');
  };

  const handleSubCategoryChange = async (e: any) => {
    const subCategoryId = e.target.value;
    setSubCategoriesValue(subCategoryId);

    // Fetch data based on selected values
    await handleGetProductByMainGroupCategory(
      mainGroupValue,
      divisionValue,
      categoryValue,
      subCategoryId
    );
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setSelectedData(null!);
  };

  const handleClickEditButton = () => {
    setOpenForm(true);
    setOpenMenu(null!);
    setSelectedData(data?.filter((item) => item?.id === selectedId)[0]);
    setIsFormUpdateData(true);
  };

  const handleClickAddButton = () => {
    setOpenForm(true);
    setSelectedData(null!);
    setIsFormUpdateData(false);
  };

  const handleFilterDataByItemCode = async () => {
    try {
      setLoading(true);
      const res = await axios.post(PRODUCT_FIND_MANY, {
        filtter: {
          merchantId: merchant,
          itemcode: searchRef.current.value,
        },
      });
      if (res?.data?.length > 0) {
        setData(res?.data[0]);
      } else {
        setData([]);
      }
    } catch (err) {
      // console.log('error=', err);
      window.alert('Server error please try again');
    } finally {
      setLoading(false);
    }
  };

  const handleClickDeleteButton = () => {
    setOpenMenu(null);
    setOpenDeleteDialog(true);
  };

  const handleDeleteAllProductByMerchant = () => {
    data?.map(async (subItem) => {
      try {
        await axios.delete(`${PRODUCT_DELETE}?id=${subItem?.id}`);
        setData(data?.filter((item) => item?.id !== subItem?.id));
      } catch (err) {
        // console.log('err=', err);
      }
    });
  };

  const handleDeleteData = async () => {
    try {
      setLoadingDelete(true);
      await axios.delete(`${PRODUCT_DELETE}?id=${selectedId}`);
      setData(data?.filter((item) => item?.id !== selectedId));
      setOpenDeleteDialog(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const filterProductStatus: ProductMerchantModel[] = data?.filter((item: ProductMerchantModel) => {
    if (productStatusType === ProductBadgeEnum.AllProduct) {
      return true;
    } else if (productStatusType === ProductBadgeEnum.NewProduct) {
      return item?.productNew === true;
    } else if (productStatusType === ProductBadgeEnum.RecommendProduct) {
      return item?.recommend === true;
    }
    return false;
  });

  const filterDataByCategory = filterProductStatus.filter((item) => {
    if (
      mainGroupValue === 'All' &&
      divisionValue === 'All' &&
      categoryValue === 'All' &&
      subCategoriesValue === 'All'
    ) {
      return true;
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue === 'All' &&
      categoryValue === 'All' &&
      subCategoriesValue === 'All'
    ) {
      return item?.productMainGroupId === mainGroupValue;
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue === 'All' &&
      subCategoriesValue === 'All'
    ) {
      return (
        item?.productMainGroupId === mainGroupValue && item?.productDivisionNameId === divisionValue
      );
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue !== 'All' &&
      subCategoriesValue === 'All'
    ) {
      return (
        item?.productMainGroupId === mainGroupValue &&
        item?.productDivisionNameId === divisionValue &&
        item?.productCategoryId === categoryValue
      );
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue !== 'All' &&
      subCategoriesValue !== 'All'
    ) {
      return (
        item?.productMainGroupId === mainGroupValue &&
        item?.productDivisionNameId === divisionValue &&
        item?.productCategoryId === categoryValue &&
        item?.productSubCategoryId === subCategoriesValue
      );
    } else {
      return false;
    }
  });

  const filterData = filterDataByCategory;

  const rows = data.slice((currentPage - 1) * 10, currentPage * 10);
  const countPagination = Math.ceil(data.length / 10);
  const isSearchNotFound: boolean = !data.length && !!searchValue;

  // useEffect
  useEffect(() => {
    if (isInit && dataExportCsv.length > 0) {
      if (buttonExportCsv.current) {
        buttonExportCsv.current.link.click();
      }
    } else {
      setIsInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataExportCsv]);

  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    selectedCheckboxId,
    onDeleteData,
    searchValue,
    onSearch,
    // filterData,
    onSelectCheckBoxAll,
    rows,
    openMenu,
    onCloseMenu,
    onOpenMenu,
    onOpenForm,
    onCloseForm,
    openForm,
    onChangePage,
    currentPage,
    isSearchNotFound,
    onSelectCheckBox,
    onDeleteSelectedData,
    countPagination,
    loading,
    handlePageChange,
    loadingFetchDataMore,
    selectedData,
    countAllProduct,
    dataBrand,
    dataMainGroup,
    dataDivisions,
    dataCategories,
    dataSubCategories,
    handleGetData,
    dataMerchants,
    merchant,
    handleMerchantChange,
    handleFilterDataByItemCode,
    searchRef,
    handleOpenForm,
    openDeleteDialog,
    loadingDelete,
    handleCloseDeleteDialog,
    handleDeleteData,
    handleClickDeleteButton,
    handleClickEditButton,
    isFormUpdateData,
    handleClickAddButton,
    handleDeleteAllProductByMerchant,
    setSearchValue,
    handleSelectedStatusProduct,
    productStatusType,
    mainGroupValue,
    divisionValue,
    categoryValue,
    subCategoriesValue,
    handleChangeMainGroup: (newValue: string) => setMainGroupValue(newValue),
    handleChangeDivision: (newValue: string) => setDivisionValue(newValue),
    handleChangeCategories: (newValue: string) => setCategoryValue(newValue),
    handleChangeSubCategory: (newValue: string) => setSubCategoriesValue(newValue),
    handleMainGroupChange,
    handleDivisionChange,
    handleCategoryChange,
    handleSubCategoryChange,
    dataMainGroupForSelect,
    dataDivisionForSelect,
    dataCategoryForSelect,
    dataSubCategoryForSelect,
    buttonExportCsv,
    dataExportCsv,
    handleExportCsv,
    handleUpdateProductByCsv,
    loadingUploadData,
    handleSearch,
    handleRefreshStock,
    loadingRefreshStock,
    loadingDataTable,
    handleSearchProduct,
    loadingExportCSVButton,
    handleFetchProductMerchantById,
    handleRefreshStockFromSbcByMerchant,
  };
};
